import { Video } from "../video/video";
import { FormClass } from "../forms/form";
// import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from '../../../vendors/bodyScrollLock';
export class Popup {
	constructor(btns_open_arr, popup_id) {
		this.popupBtnsOpen = btns_open_arr;
		// window.clickedBtn = null;

		this.popupEl = document.querySelector('[data-popup="' + popup_id + '"]');
		this.popupId = popup_id;

		if (this.popupEl) {
			this.popupElWrapper = this.popupEl.querySelector("[data-popup-wrapper]");
			this.popupBtnsClose = this.popupEl.querySelectorAll("[data-popup-close]");

			// window.popupOpen = false;
			this.setEvents();

			// multilayer
			this.nextLayer_btns = this.popupEl.querySelectorAll("[data-showlayer]");
			this.multilayer = this.nextLayer_btns ? true : false;

			if (this.nextLayer_btns) {
				this.firstLayer = this.popupEl.querySelector(".popup-b2c__first-layer");
				this.popupContent = this.popupElWrapper.querySelector(
					".popup-b2c__content"
				);
				// this.nextLayers = this.popupEl.querySelectorAll('.popup-b2c__second-layer');

				[].forEach.call(this.nextLayer_btns, (btn) => {
					if (!btn.bindedPopupNextLayer) {
						btn.bindedPopupNextLayer = true;
						btn.addEventListener("click", () => this.activateLayer(btn));
					}
				});
			}

			//video popup
			this.vidPopup = this.popupEl.querySelector("[data-popupVideo]");
			if (this.vidPopup) {
				this.vid = new Video(this.vidPopup);
			}

			//set forms
			this.formPopup = this.popupEl.querySelector("[role=form]");
			if (this.formPopup) {
				this.formEl = new FormClass(this.formPopup);
			}

			this.createWCAGStuff();
		}
	}

	createWCAGStuff() {
		// console.log(this.popupElWrapper, this.popupElWrapper.querySelector('[data-popup-start]'));
		if (
			this.popupElWrapper &&
			!this.popupElWrapper.querySelector("[data-popup-end]")
		) {
			this.popupElWrapper.insertAdjacentHTML(
				"afterbegin",
				'<div tabindex="0" aria-hidden data-popup-start></div>'
			);
			this.popupElWrapper.insertAdjacentHTML(
				"beforeend",
				'<div tabindex="0" aria-hidden data-popup-end></div>'
			);
		}
	}

	setEvents() {
		[].forEach.call(this.popupBtnsOpen, (el) => {
			if (!el.bindedPopupOpen) {
				el.bindedPopupOpen = true;
				el.addEventListener("click", (e) => {
					e.preventDefault();
					this.openPopup(e);
					let hamburger = document.querySelector(".main-navigation__hamburger");
					if (hamburger.classList.contains("active")) {
						hamburger.click();
					}
				});
			}
		});

		[].forEach.call(this.popupBtnsClose, (el) => {
			// var new_element = el.cloneNode(true);
			// el.parentNode.replaceChild(new_element, el);
			// new_element.addEventListener('click', (e) => {
			// 	this.closePopup();
			// });
			if (!el.bindedPopupClose) {
				el.bindedPopupClose = true;
				el.addEventListener("click", (e) => {
					this.closePopup();
				});
			}
		});

		if (!this.popupEl.bindedPopupClose) {
			this.popupEl.bindedPopupClose = true;
			this.popupEl.addEventListener("mousedown", (e) => {
				this.closePopup();
			});
		}

		this.popupElWrapper.addEventListener("mousedown", this.stopProp);

		if (!window.bindedPopupKeyDown) {
			window.bindedPopupKeyDown = [];
		}
		if (!window.bindedPopupKeyDown[this.popupId + ""]) {
			window.bindedPopupKeyDown[this.popupId + ""] = true;
			window.addEventListener("keydown", (e) => {
				if (window.popupOpen) {
					const keyCode = e.keyCode;
					const activeEl = document.activeElement;
					if (keyCode === 27) this.closePopup();
					if (
						keyCode == 9 &&
						!e.shiftKey &&
						activeEl.hasAttribute("data-popup-end")
					) {
						this.popupElWrapper.querySelector("[data-popup-start]").focus();
					}
					if (
						keyCode == 9 &&
						e.shiftKey &&
						activeEl.hasAttribute("data-popup-start")
					) {
						this.popupElWrapper.querySelector("[data-popup-end]").focus();
					}
				}
			});
		}
	}

	stopProp(e) {
		e.stopPropagation();
	}

	openPopup(e) {
		e.preventDefault();

		window.clickedBtn = e.currentTarget;

		const ID = window.clickedBtn.getAttribute("data-parameter-id");
		const VALUE = window.clickedBtn.getAttribute("data-parameter-value");
		const FORM = this.popupEl.querySelector(".form");
		const INPUT = document.createElement("input");
		const DIV = document.createElement("div");
		const ADD_DIV = this.popupEl.querySelector("[data-dynamic-input]");

		if (ADD_DIV) {
			ADD_DIV.remove();
		}

		INPUT.setAttribute("id", ID);
		INPUT.setAttribute("name", ID);
		INPUT.setAttribute("type", "hidden");
		INPUT.value = VALUE;
		DIV.classList.add("form-group");
		DIV.setAttribute("data-dynamic-input", "true");
		DIV.appendChild(INPUT);
		if (FORM) {
			FORM.appendChild(DIV);
		}
		this.addDynamicInputs();

		// bodyScrollLock.disableBodyScroll(this.popupEl);
		bodyScrollLock.disableBodyScroll(
			this.popupEl.querySelector(".popup-b2c__wrapper")
		);
		if (this.popupEl.querySelector(".channels-popup__content")) {
			bodyScrollLock.disableBodyScroll(
				this.popupEl.querySelector(".channels-popup__content")
			);
		}
		if (this.popupEl.querySelector(".pricing-simulator__long-list")) {
			bodyScrollLock.disableBodyScroll(
				this.popupEl.querySelector(".pricing-simulator__long-list")
			);
		}

		this.popupEl.classList.add("is-active");
		this.popupElWrapper.setAttribute("aria-hidden", "false");
		window.popupOpen = true;
		setTimeout(() => {
			this.popupElWrapper.focus();
		}, 200);
		if (this.vidPopup) {
			if (this.vidPopup.getAttribute("data-popupVideo") == "autoplay") {
				this.vid.playVideo();
			}
		}
		if (this.formPopup && !this.formPopup.hasAttribute("data-sdu-form")) {
			this.formEl.resetForm();
		}
	}
	addDynamicInputs() {
		const PARAMS = JSON.parse(window.clickedBtn.getAttribute("data-parameters"));
		const FORM = this.popupEl.querySelector(".form");
		const DIV = document.createElement("div");
		const ADD_DIV = this.popupEl.querySelector("[data-dynamic-inputs]");

		if (ADD_DIV) {
			ADD_DIV.remove();
		}

		for (let key in PARAMS) {
			const INPUT = document.createElement("input");
			INPUT.setAttribute("id", key);
			INPUT.setAttribute("name", key);
			INPUT.setAttribute("type", "hidden");
			INPUT.value = PARAMS[key];
			DIV.appendChild(INPUT);
		}

		DIV.classList.add("form-group");
		DIV.setAttribute("data-dynamic-inputs", "true");
		if (FORM) {
			FORM.appendChild(DIV);
		}
	}
	closePopup() {
		bodyScrollLock.clearAllBodyScrollLocks();
		this.popupEl.classList.remove("is-active");
		window.popupOpen = false;
		if (window.clickedBtn) {
			window.clickedBtn.focus();
			window.clickedBtn = null;
		}

		if (this.nextLayer_btns) {
			this.hideLayers(this.popupEl);
		}
		if (this.vidPopup) {
			this.vid.stopVideo();
		}
		if (this.formPopup) {
		}
		if (this.popupId === "exit") {
			sessionStorage.setItem("popup_exit", "showed");
		}
		this.popupElWrapper.setAttribute("aria-hidden", "true");
	}

	//---------------------------------popup-circles

	activateLayer(btn) {
		const className = btn.getAttribute("data-showlayer");
		const secondLayer = this.popupContent.querySelector("." + className);
		this.firstLayer.classList.add("hide-layer");
		secondLayer.classList.add("show-layer");
		this.setHeight();
		if (secondLayer) $.fn.matchHeight._update();
	}
	setHeight() {
		const activeLayer = this.popupContent.querySelector(".show-layer");
		if (activeLayer) {
			if (activeLayer.clientHeight != this.popupContent.clientHeight) {
				this.popupContent.style.height = activeLayer.clientHeight + "px";
			}
			$.fn.matchHeight._update();
		}
	}
	hideLayers(popup) {
		const secondLayer = popup.querySelector(".popup-b2c__second-layer");
		const firstLayer = popup.querySelector(".popup-b2c__first-layer");
		if (secondLayer == null) return;
		secondLayer.classList.remove("show-layer");
		firstLayer.classList.remove("hide-layer");
		popup.querySelector(".popup-b2c__content").style.height = "";
	}
}
